import { useState } from 'react';
import { required, TextInput, useTranslate } from 'react-admin';
import { useController, useFormContext } from 'react-hook-form';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, InputAdornment } from '@mui/material';
import { Autocomplete, useLoadScript } from '@react-google-maps/api';
import { INPUT_SOURCE } from '../../objects';

const GOOGLE_MAPS_API_KEY = 'AIzaSyBFQgfSQw4yohnKwchrKuqD8VgH8-eCkS8';

export const GoogleAutocompleteInput = ({
	isRequired
}: {
	isRequired?: boolean;
}) => {
	const translate = useTranslate();
	const { setValue } = useFormContext();
	const [searchResult, setSearchResult] =
		useState<google.maps.places.Autocomplete>();
	const { isLoaded } = useLoadScript({
		googleMapsApiKey: GOOGLE_MAPS_API_KEY,
		libraries: ['places'],
		region: 'ua'
	});

	const {
		field: { value, onChange }
	} = useController({ name: INPUT_SOURCE.ADDRESS });

	const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
		setSearchResult(autocomplete);
	};

	const onPlaceChanged = () => {
		if (searchResult != null) {
			const place = searchResult.getPlace();
			const formattedAddress = place.formatted_address;

			setValue(INPUT_SOURCE.LOCATION_DATA, {
				locationUrl: place.url
			});
			onChange(formattedAddress);
		}
	};

	if (!isLoaded) {
		return <div>Loading...</div>;
	}

	return (
		<Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad}>
			<TextInput
				source={INPUT_SOURCE.ADDRESS}
				value={value}
				placeholder={translate('form.fields.addressPlaceholder')}
				label={translate('form.fields.address')}
				slotProps={{
					input: {
						endAdornment: value ? (
							<InputAdornment position="end" sx={{ cursor: 'pointer' }}>
								<IconButton
									sx={{
										width: 28,
										height: 28
									}}
									onClick={() => {
										setValue(INPUT_SOURCE.LOCATION_DATA, {});
										setValue(INPUT_SOURCE.ADDRESS, '');
									}}
								>
									<ClearIcon fontSize="small" />
								</IconButton>
							</InputAdornment>
						) : null
					}
				}}
				validate={isRequired ? required() : undefined}
			/>
		</Autocomplete>
	);
};
